import DataLoader from "dataloader"
import { useSuspenseQuery } from "@tanstack/react-query"
import { get } from "../typed-client/get"
import { SimpleUser } from "@/orval/gen/model/simpleUser"

const loader = new DataLoader<number, SimpleUser | null>(
  async (keys) => {
    const results = await get("/api/User/GetSimpleUsersWithNames", {
      userIds: [...keys],
    })
    return keys.map((key) => results.find((x) => x.userId === key) || null)
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedSimpleUser(userId: number) {
  return useSuspenseQuery({
    queryKey: ["SimpleUser", userId],
    queryFn: () => loader.load(userId),
  })
}
